import { Box } from '@mui/material'
import { css } from '@emotion/react'
import styled from '@emotion/styled'

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: 16px;
`

export const Title = styled(Box)`
  ${({ theme }) => css`
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: 180%;
    margin-bottom: 32px;
    text-align: center;
    color: ${theme.colors.secondary};
  `}
`
